// extracted by mini-css-extract-plugin
module.exports = {"varBackgroundLightContrast2":"var(--tkww-union-color-background-light-contrast-2, var(--tkww-union-color-neutral-200, #E4E5E9))","varSpUp3":"1.75rem","divider":"divider--c3a10"};